var render = function render(){var _vm=this,_c=_vm._self._c;return _c('td',{staticClass:"main-table-td-header",class:{ subheader: _vm.subheader },style:({
    color: _vm.header.textColor && `${_vm.header.textColor} !important`,
    backgroundColor: _vm.header.backgroundColor && `${_vm.header.backgroundColor} !important`,
  }),attrs:{"colspan":_vm.headerColumns}},[_c('span',{staticClass:"text"},[_vm._v(" "+_vm._s(_vm.header.value)+" ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }